<template>
  <div class="not-found-page">
    <div class="title">
      <svg width="533" height="221" viewBox="0 0 533 221" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M163.522 141.768C164.627 141.768 165.522 142.663 165.522 143.768V178.625C165.522 179.73 164.627 180.625 163.522 180.625H144.744C143.639 180.625 142.744 181.52 142.744 182.625V214.75C142.744 215.855 141.848 216.75 140.744 216.75H102.528C101.424 216.75 100.528 215.855 100.528 214.75V182.625C100.528 181.52 99.6327 180.625 98.5282 180.625H2C0.895434 180.625 0 179.73 0 178.625V142.252C0 141.934 0.0759858 141.62 0.22164 141.337L70.2063 5.33488C70.5491 4.66871 71.2354 4.25 71.9846 4.25H112.442C113.937 4.25 114.904 5.83115 114.222 7.16201L46.7449 138.856C46.063 140.187 47.0295 141.768 48.5249 141.768H98.5282C99.6327 141.768 100.528 140.872 100.528 139.768V93.375C100.528 92.2704 101.424 91.375 102.528 91.375H140.744C141.848 91.375 142.744 92.2704 142.744 93.375V139.768C142.744 140.872 143.639 141.768 144.744 141.768H163.522ZM265.467 221C238.943 221 218.088 210.982 202.902 190.946C187.919 170.708 180.428 143.893 180.428 110.5C180.428 77.1071 187.919 50.3929 202.902 30.3571C218.088 10.119 238.943 0 265.467 0C292.193 0 313.048 10.119 328.031 30.3571C343.014 50.3929 350.506 77.1071 350.506 110.5C350.506 143.893 343.014 170.708 328.031 190.946C313.048 210.982 292.193 221 265.467 221ZM233.273 162.411C240.562 174.149 251.294 180.018 265.467 180.018C279.64 180.018 290.371 174.048 297.66 162.107C305.151 150.167 308.897 132.964 308.897 110.5C308.897 87.8333 305.151 70.5298 297.66 58.5893C290.371 46.6488 279.64 40.6786 265.467 40.6786C251.294 40.6786 240.562 46.6488 233.273 58.5893C225.984 70.5298 222.34 87.8333 222.34 110.5C222.34 133.167 225.984 150.47 233.273 162.411ZM531 141.768C532.105 141.768 533 142.663 533 143.768V178.625C533 179.73 532.105 180.625 531 180.625H512.222C511.117 180.625 510.222 181.52 510.222 182.625V214.75C510.222 215.855 509.326 216.75 508.222 216.75H470.006C468.901 216.75 468.006 215.855 468.006 214.75V182.625C468.006 181.52 467.111 180.625 466.006 180.625H369.478C368.373 180.625 367.478 179.73 367.478 178.625V142.252C367.478 141.934 367.554 141.62 367.699 141.337L437.684 5.33488C438.027 4.66871 438.713 4.25 439.462 4.25H479.919C481.415 4.25 482.381 5.83115 481.699 7.16201L414.223 138.856C413.541 140.187 414.507 141.768 416.003 141.768H466.006C467.111 141.768 468.006 140.872 468.006 139.768V93.375C468.006 92.2704 468.901 91.375 470.006 91.375H508.222C509.326 91.375 510.222 92.2704 510.222 93.375V139.768C510.222 140.872 511.117 141.768 512.222 141.768H531Z" fill="var(--text-text-primary-accent)"/>
      </svg>
    </div>
    <div class="subtitle">
      {{ $t('preCheckout.errors.page_not_found') }}
    </div>
    <div class="text">
      {{ $t('preCheckout.errors.page_not_found_text') }}
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style lang="scss" scoped>
  .not-found-page {
    font-family: "Gilroy";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    .title {
      color: var(--text-text-primary-accent);
      font-size: 130px;
      font-weight: 800;

      text-align: center;

      padding: 0 20px;
      
      svg {
        width: 100%;
        max-width: 533px;
        height: auto;
      }
    }
    .subtitle {
      color: var(--text-text-primary);
      font-size: 32px;
      margin-top: 30px;
      font-weight: 500;
      margin-bottom: 10px;
      text-align: center;
      line-height: 100%; /* 32px */
    }
    .text {
      color: var(--text-color-text-secondary);

      text-align: center;
      font-size: 18px;
      font-weight: 500;
      line-height: 100%; /* 32px */
    }

    @include below_mobile {
      .title {
        font-size: 130px;
      }
      .subtitle {
        font-size: 22px;
      }
      .text {
        font-size: 14px;
      }
    }
  }
</style>
